import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from '../../app.config';
@Component({
  selector: 'app-managepuzzles',
  templateUrl: './managepuzzles.component.html',
  styleUrls: ['./managepuzzles.component.css']
})
export class ManagepuzzlesComponent implements OnInit {

  constructor(public appConfig: AppConfig, private router: Router) { }

  ngOnInit() {


  }

  onChildData(data) {
    switch (data.key) {
      case 'start':
        this.router.navigate(["/elearning/puzzles/start/" + data.val]);
        break;
      case 'backToElearning':
        this.router.navigate(["/elearning"]);
        break;

    }
  }
}
